<template>
  <div class="bar-tile">
    <div class="text-h5 mb-4">
      {{ heading ? heading : data.name }}
    </div>
    <v-card class="bar-tile__card">
      <div class="py-4 pl-6">
        {{ data.name }}
      </div>
      <v-divider />
      <bar-chart
        class="bar-tile__chart"
        :organisation-name="organisationName"
        :class="{ 'bar-tile__chart--single' : singleChart }"
        :chart-data="data.chartdata"
        v-if="!isEmpty"
        @redirectToEvent="redirect($event)"
        :singleChart="singleChart"
      />
    </v-card>
  </div>
</template>

<script>
const BarChart = () => import('@/components/BarChartTile/BarChart.vue');

export default {
  name: 'BarChartTile',
  components: {
    BarChart,
  },
  data() {
    return {
      //@TODO this is not used, which one is real?
      //organisationName: this.$route.query.org_name,
    }
  },
  props: {
    organisationName: {
      type: String,
    },
    data: {
      type: Object,
      required: true,
    },
    hasBackground: {
      type: Boolean,
      required: false,
      default: true,
    },
    heading: {
      type: String,
      required: false,
    },
    singleChart: {
      type: Boolean,
      required: false,
      default: false,
    },
    timeStart: {
      type: [String, Number],
      required: true,
    },
    timeEnd: {
      type: [String, Number],
      required: true,
    },
    client: {
      type: String,
      required: true,
    }
  },
  methods: {
    redirect() {
      this.$router.push(
        `/events-log?f=${this.timeStart}&t=${this.timeEnd}&org=${this.client}&c=${this.$route.query.c}&a=${this.$route.query.a}&i=${this.$route.query.i}`
      );
    },
  },
};
</script>

<style lang="scss" src="./BarChartTile.scss" />
